import * as accounts from './EstService/Accounts';
import * as appointments from './EstService/Appointments';
import * as auth from './EstService/Auth';
import * as customers from './EstService/Customers';
import * as dashboards from './EstService/Dashboards';
import * as invoices from './EstService/Invoices';
import * as tags from './EstService/Tags';
import * as parts from './EstService/Parts';
import * as services from './EstService/Services';
import * as vendors from './EstService/Vendors';
import * as notifications from './EstService/Notifications';
import * as subscriptions from './EstService/Subscriptions';
import * as accountSubscriptions from './EstService/AccountSubscriptions';
import * as billing from './EstService/Billing';
import * as support from './EstService/Support';

const EstService = {
	...accounts,
	...appointments,
	...auth,
	...customers,
	...dashboards,
	...invoices,
	...tags,
	...parts,
	...services,
	...vendors,
	...notifications,
	...subscriptions,
	...accountSubscriptions,
	...billing,
	...support,
};

export default EstService;
